import { Card, Col, Image, Row } from "antd";
import { useDrag } from "react-dnd";
import { Slot } from "services/admin/core/machine/slot/types";
import { Prekitting } from "services/admin/core/trip/types";
import { Product } from "services/admin/menu/product/types";
import { fileToUrl } from "utils";
import "./styles.scoped.less";
import { renderMoney } from "utils";

const { Meta } = Card;
interface Props {
  product?: Product;
  price?: number;
  slot?: Slot;
  prekitting?: Prekitting;
  onClick?: () => void | undefined;
}
const ProductCard: React.FC<Props> = ({
  price,
  slot,
  product,
  onClick,
  prekitting,
}) => {
  const [, drag] = useDrag({
    type: "slot_product_card",
    item: {
      id: slot?.id,
      slot: `${slot?.row}${slot?.column}`,
      type: slot?.type,
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <div ref={slot ? drag : null}>
      <Card
        size="small"
        style={{
          width: globalThis.screen.width < 1200 ? 300 : "unset",
          padding: 1,
          minHeight: "220px",
          height: "100%",
        }}
        hoverable
        cover={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: 150,
              overflow: "hidden",
            }}
          >
            <Image
              onClick={() => {
                if (onClick) onClick();
              }}
              style={{
                height: "200px",
                objectFit: "contain",
                display: "block",
                margin: "auto",
              }}
              alt="example"
              preview={false}
              src={
                product?.image_path
                  ? fileToUrl(product.image_path)
                  : "/no-image.png"
              }
            />
            {!prekitting && <div className="style_flag">{renderMoney(price)}₮</div>}
            {slot && (
              <div
                className="style_flag"
                style={{
                  top: "3rem",
                  background: slot.product_id
                    ? slot.current_size > 0
                      ? "#d9f7be"
                      : "rgb(255, 156, 162)"
                    : "#fff1b8",
                  color: "var(--kit-color-primary)",
                }}
              >
                {`${slot.row}${slot.column} (${slot.current_size}/${slot.max_size})`}
              </div>
            )}
            {prekitting && (
              <div className="style_flag" style={{ top: "3rem" }}>
                {`${prekitting.total_current}/${prekitting.max_capacity}`}
              </div>
            )}
            {prekitting && (
              <div className="style_flag">
                {`Авах хэмжээ: ${prekitting.needed_size}`}
              </div>
            )}
          </div>
        }
      >
        <Meta
          description={
            <Row onClick={onClick}>
              <Col span={24} className="card-title">
                {product?.name}
              </Col>
            </Row>
          }
        />
      </Card>
    </div>
  );
};

export default ProductCard;
